import { useTranslation } from "react-i18next";
import PrimaryBtn from "../../common/form/PrimaryBtn";
import { useNavigate, useParams } from "react-router-dom";
import img1 from "../../../assets/images/places/img1.png";
import img2 from "../../../assets/images/places/img2.png";
import img3 from "../../../assets/images/places/img3.png";
import img4 from "../../../assets/images/places/img4.png";
import img5 from "../../../assets/images/places/img5.png";
import img6 from "../../../assets/images/places/img6.png";
import img7 from "../../../assets/images/places/img7.png";
import img8 from "../../../assets/images/places/img8.png";
import img9 from "../../../assets/images/places/img9.png";
import img10 from "../../../assets/images/places/img10.png";
import img11 from "../../../assets/images/places/img11.png";
import img12 from "../../../assets/images/places/img12.png";
import img13 from "../../../assets/images/places/img13.png";
import img14 from "../../../assets/images/places/img14.png";
import img15 from "../../../assets/images/places/img15.png";
import Marquee from "react-fast-marquee";

const Places = () => {
    const { t } = useTranslation('common');
    const params = useParams();
    const navigate = useNavigate();
    const imgList1: any[] = [img1, img2, img3, img4, img14]
    const imgList2: any[] = [img5, img6, img7, img8, img9]
    const imgList3: any[] = [img10, img11, img12, img13, img15]

    return (
        <div className="bg-[#F6F6F6] dark:bg-[#0b121a] w-full overflow-hidden relative z-[1] h-[450px] sm:h-[500px] lg:h-[600px] xlx:h-[690px]">
            {/* h-[690px] */}
            <div className="absolute top-0 left-0 bottom-0 right-0 z-[2] xl:hidden place-bg"></div>
            <div className="container flex h-full items-center justify-start xl:justify-center gap-[43px] relative z-[3]">
                <div className="w-full md:w-[500px] xl:block hidden"></div>
                <div className="flex flex-col w-full md:min-w-[500px] h-full justify-center xl:absolute xl:top-0 xl:left-0 xl:bottom-0 xl:right-0 xl:pl-[18px]">
                    <div className="flex flex-col">
                        <h3 className="text-blackDark dark:text-textBlackDull font-bold">{t("passenger.home.places.title")}</h3>
                        <h1 className="font-bold text-secPurple max-w-[330px] xlx:max-w-[445px]">{t("passenger.home.places.subtitle")}</h1>
                    </div>

                    <h2 className="text-blackDark dark:text-textBlackDull font-medium mt-[15px] xlx:mt-[25px] mb-[20px] xlx:mb-[40px] max-w-[380px] xlx:max-w-[465px] text-base leading-snug">{t("passenger.home.places.desc")}</h2>

                    <PrimaryBtn title={t("passenger.home.places.explore_now")} onClick={() => !!params?.lang ? navigate(`/${params?.lang}/tours`) : navigate(`/tours`)} />
                </div>

                <div className="w-full xl:block hidden h-full rotate-[-15deg] 1.5xl:mr-[-8%]">
                    {/* rotate-[-15deg] */}
                    {/* <img src={require("../../../assets/images/place.png")} alt="places" /> */}
                    <div className="w-full h-full rotate-[90deg]" >
                        <Marquee speed={30} direction="right">
                            {Array.isArray(imgList3) && imgList3?.map((item: any, index: number) => (
                                <img src={item} alt="places" key={index} className="rounded-[30px] w-[200px] h-[217px] rotate-[-90deg] mr-[35px]" />
                            ))}
                        </Marquee>
                        <Marquee speed={30} direction="left">
                            {Array.isArray(imgList2) && imgList2?.map((item: any, index: number) => (
                                <img src={item} alt="places" key={index} className="rounded-[30px] w-[200px] h-[217px] rotate-[-90deg] mr-[35px]" />
                            ))}
                        </Marquee>
                        <Marquee speed={30} direction="right">
                            {Array.isArray(imgList1) && imgList1?.map((item: any, index: number) => (
                                <img src={item} alt="places" key={index} className="rounded-[30px] w-[200px] h-[217px] rotate-[-90deg] mr-[35px]" />
                            ))}
                        </Marquee>
                    </div>
                </div>
            </div>
            <div className="absolute top-0 right-0 bottom-0 left-0 z-[1] h-full xl:hidden flex items-center justify-center w-full rotate-[-15deg]">
                {/* <img src={require("../../../assets/images/place.png")} alt="places" className="w-full h-full object-cover" /> */}
                <div className="w-full h-full rotate-[90deg]" >
                    <Marquee speed={30} direction="right" className="place-marguee">
                        {Array.isArray(imgList3) && imgList3?.map((item: any, index: number) => (
                            <img src={item} alt="places" key={index} className="rounded-[30px] w-[150px] h-[167px] xsm:w-[170px] xsm:h-[187px] sm:w-[200px] sm:h-[217px] rotate-[-90deg] mr-[35px]" />
                        ))}
                    </Marquee>
                    <Marquee speed={30} direction="left" className="place-marguee">
                        {Array.isArray(imgList2) && imgList2?.map((item: any, index: number) => (
                            <img src={item} alt="places" key={index} className="rounded-[30px] w-[150px] h-[167px] xsm:w-[170px] xsm:h-[187px] sm:w-[200px] sm:h-[217px] rotate-[-90deg] mr-[35px]" />
                        ))}
                    </Marquee>
                    <Marquee speed={30} direction="right" className="place-marguee">
                        {Array.isArray(imgList1) && imgList1?.map((item: any, index: number) => (
                            <img src={item} alt="places" key={index} className="rounded-[30px] w-[150px] h-[167px] xsm:w-[170px] xsm:h-[187px] sm:w-[200px] sm:h-[217px] rotate-[-90deg] mr-[35px]" />
                        ))}
                    </Marquee>
                </div>
            </div>
        </div>
    );
};

export default Places;